export enum LoggedInState {
  loggedOut,
  checking,
  loginPopup,
  gotIdToken,
  attemptAcquireTokenSilently,
  acquireTokenPopup,
  tokenAcquired,
  loadingUser,
  loggedIn,
  error
}
